var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoomoneyLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#8b3ffd",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.7 5a7.01 7.01 0 1 0-.02 14.02A7.01 7.01 0 0 0 18.7 5m0 9.6a2.62 2.62 0 0 1-2.6-2.6c0-1.43 1.18-2.6 2.61-2.6a2.63 2.63 0 0 1 2.62 2.6 2.65 2.65 0 0 1-2.62 2.6Zm-7.02-7.57v10.19H9.19L6 7.03z"
})));
export default SvgYoomoneyLight;